export const MAINTENANCE_ROUTE = "/maintenance";
